var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b({ disabled: _vm.disabled })},[_c('div',{class:_vm.b('header')},[_c('div',{class:_vm.b('number')},[_vm._v(_vm._s(_vm.number))]),_c('div',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.title))])]),_c('div',{class:_vm.b('content')},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }